// Centralized admin email configuration
// Update this file to manage admin emails in one place
//
// IMPORTANT: When updating admin emails, also update:
// - /firebase/firestore.rules (isAdmin function around line 122-126)
// The firestore.rules file cannot import JavaScript, so it must be manually synchronized

export const ADMIN_CONFIG = {
    emails: [
        'admin@cycleofhelp.com',
        'casabarulli2013@gmail.com'
        // Add more admin emails as needed
    ]
};

// Helper function to check if an email is an admin email
export function isAdminEmail(email) {
    return ADMIN_CONFIG.emails.includes(email);
}